var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextColor2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "-7 -7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.875 17l2.162-5.647M13.125 17l-.766-2m-9.322-3.647L7 1l2.372 6.196m-6.335 4.157H8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.333C15 13.358 13.433 15 11.5 15S8 13.358 8 11.333 11.5 4 11.5 4 15 9.308 15 11.333z"
  })));
}

export default SvgTextColor2;